import { defineComponent, Types } from "bitecs";

export const Position = defineComponent({
  x: Types.f32,
  y: Types.f32,
  z: Types.f32,
});

export const Velocity = defineComponent({
  x: Types.f32,
  y: Types.f32,
  z: Types.f32,
});

export const Rotation = defineComponent({
  yaw: Types.f32,
  pitch: Types.f32,
});

export const Health = defineComponent({
  current: Types.f32,
  max: Types.f32,
});

export const Player = defineComponent({
  clientId: Types.ui32,
  isLocal: Types.ui8,
});

export const EcsInventory = defineComponent({
  slots: [Types.ui16, 36],
  counts: [Types.ui8, 36],
  selectedSlot: Types.ui8,
});

export const PhysicsBody = defineComponent({
  width: Types.f32,
  height: Types.f32,
  onGround: Types.ui8,
  gravity: Types.f32,
});

export const MobAI = defineComponent({
  mobType: Types.ui8,
  state: Types.ui8,
  targetEntity: Types.ui32,
  aggroRange: Types.f32,
});

// Mob types
export const MOB_TYPE = {
  ZOMBIE: 0,
  SKELETON: 1,
  PIG: 2,
  COW: 3,
} as const;

// AI states
export const AI_STATE = {
  IDLE: 0,
  WANDER: 1,
  CHASE: 2,
  ATTACK: 3,
  FLEE: 4,
} as const;
